/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Helpcentre_Permissions_Noeditaccess3Inputs */

const en_helpcentre_permissions_noeditaccess3 = /** @type {(inputs: Helpcentre_Permissions_Noeditaccess3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have permission to view this page`)
};

/**
* | output |
* | --- |
* | "You do not have permission to view this page" |
*
* @param {Helpcentre_Permissions_Noeditaccess3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const helpcentre_permissions_noeditaccess3 = /** @type {((inputs?: Helpcentre_Permissions_Noeditaccess3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Helpcentre_Permissions_Noeditaccess3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_helpcentre_permissions_noeditaccess3(inputs)
});
export { helpcentre_permissions_noeditaccess3 as "helpCentre_permissions_noEditAccess" }